import { AccountsApiService } from '@accounts/domain';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LockedAccountApiService extends AccountsApiService {
  readonly API_URL = `/v1/accounts`;
  private _lockedUserEmail: string;

  setLockedUserEmail(email: string): void {
    this._lockedUserEmail = email;
  }

  getLockedUserEmail(): string {
    return this._lockedUserEmail;
  }

  resendRecoveryEmail(origin: string): Observable<boolean> {
    return this._post(`${this.API_URL}/unlock`, {
      email: this._lockedUserEmail,
      origin,
    }).pipe(
      map((res) => this._handleResponse(res, 'success')),
      catchError((res) => this._handleError(res)),
    );
  }
}
